export function formatRemainingDownloads(remainingDownloads: number | null | undefined) {
  if (typeof remainingDownloads !== 'number' || !Number.isFinite(remainingDownloads)) return '-';
  return `${Math.max(0, Math.floor(remainingDownloads))}/5`;
}
